import validate from "/app/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.5.1_@types+node@20.10.1_db0@0.3.2_encoding@0.1.13_eslint@_33360446c538a4775ce6601c843b1073/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirect_45global from "/app/app/platform/middleware/01.redirect.global.ts";
import _02_45auth_45global from "/app/app/platform/middleware/02.auth.global.ts";
import _03_45store_45global from "/app/app/platform/middleware/03.store.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.5.1_@types+node@20.10.1_db0@0.3.2_encoding@0.1.13_eslint@_33360446c538a4775ce6601c843b1073/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45redirect_45global,
  _02_45auth_45global,
  _03_45store_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}